/* eslint-disable */
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
// import firebase from './plugins/firebase'
import vuetify from './plugins/vuetify'
import { nextTick } from 'vue'
import i18n from './plugins/i18n'
import { loadFonts } from './plugins/webfontloader'
import { registerPwaServiceWorker } from './plugins/pwa'
import '@/assets/main.scss'

loadFonts()
registerPwaServiceWorker()

if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.global.locale.value
}

if (typeof window !== 'undefined') {
  window.requestIdleCallback?.(() => {
    import('./plugins/analytics').then(({ initAnalytics }) => initAnalytics())
  }) || setTimeout(() => {
    import('./plugins/analytics').then(({ initAnalytics }) => initAnalytics())
  }, 1500)
}

const pinia = createPinia()
const head = createHead()

const app = createApp(App)

app
  .use(pinia)
  .use(router)
  .use(vuetify)
  // .use(firebase)
  .use(i18n)
  .use(head)

// 인증 가드가 끝날 때까지 프리렌더 HTML을 유지한 뒤 마운트
// (가드 대기 중 앱 셸이 깜빡이지 않도록)
router.isReady().then(async () => {
  app.mount('#app')
  await nextTick()
  // useHead가 title/meta를 쓴 뒤에 캡처해야 검색엔진이 기본 HTML 제목을 보지 않는다.
  await nextTick()
  await new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(resolve))
  })
  document.dispatchEvent(new Event('prerender-ready'))
})
